import React, { Component, Fragment } from 'react';
import * as Func from '../../../../../helpers/functions';
import { ListComponent, FilterDropdown, StatusComponent } from "../../../common/component/Index";
import Promotion from './../../../../../models/Promotion';
import { withTranslation } from "react-i18next";
import { Icon, Tooltip } from 'antd';
import { DATE_TIME_FORMAT } from '../../../../../constants/Define';
import moment from "moment";

const ListCols = [
    // 'campaignCode', 
    'campaignName', 
    'bundleName', 
    'isActive',
    // 'bundleCode', 
    'promotionCode', 
    'maxCount', 
    'usedCount', 
    'promotionHistorys',
    'updateAt',
    'schedules'
    // 'channel'
];
const ModelFields = Object.getOwnPropertyNames(new Promotion());

class PromotionList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            titleItemTable: Func.getTitleTable(ListCols, ['action'], []),
            modelItem: ModelFields,
            componentTable: {
                campaignCode: {
                    key: 'campaignCode',
                    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                        <FilterDropdown
                            setSelectedKeys={setSelectedKeys}
                            selectedKeys={selectedKeys}
                            confirm={confirm}
                            clearFilters={clearFilters}
                            handleSearch={this.handleSearch}
                            handleReset={this.handleReset}
                        >
                        </FilterDropdown>
                    ),
                    filterIcon: filtered => (
                        <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
                    ),
                    render: (text, record) => text
                },
                campaignName: {
                    key: 'campaignName',
                    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                        <FilterDropdown
                            setSelectedKeys={setSelectedKeys}
                            selectedKeys={selectedKeys}
                            confirm={confirm}
                            clearFilters={clearFilters}
                            handleSearch={this.handleSearch}
                            handleReset={this.handleReset}
                        >
                        </FilterDropdown>
                    ),
                    filterIcon: filtered => (
                        <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
                    ),
                    render: (text, record) => text
                },
                bundleName: {
                    key: 'bundleName',
                    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                        <FilterDropdown
                            setSelectedKeys={setSelectedKeys}
                            selectedKeys={selectedKeys}
                            confirm={confirm}
                            clearFilters={clearFilters}
                            handleSearch={this.handleSearch}
                            handleReset={this.handleReset}
                        >
                        </FilterDropdown>
                    ),
                    filterIcon: filtered => (
                        <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
                    ),
                    render: (text, record) => text
                },
                bundleCode: {
                    key: 'bundleCode',
                    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                        <FilterDropdown
                            setSelectedKeys={setSelectedKeys}
                            selectedKeys={selectedKeys}
                            confirm={confirm}
                            clearFilters={clearFilters}
                            handleSearch={this.handleSearch}
                            handleReset={this.handleReset}
                        >
                        </FilterDropdown>
                    ),
                    filterIcon: filtered => (
                        <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
                    ),
                    render: (text, record) => text
                },
                promotionCode: {
                    key: 'promotionCode',
                    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                        <FilterDropdown
                            setSelectedKeys={setSelectedKeys}
                            selectedKeys={selectedKeys}
                            confirm={confirm}
                            clearFilters={clearFilters}
                            handleSearch={this.handleSearch}
                            handleReset={this.handleReset}
                        >
                        </FilterDropdown>
                    ),
                    filterIcon: filtered => (
                        <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
                    ),
                    render: (text, record) => text
                },
                maxCount: {
                    key: 'maxCount',
                    render: (text, record) => text < 0 ? 
                                            <StatusComponent color={'green'} label={this.props.t('item.promotions.unlimited')} />
                                            :  text
                },
                promotionHistorys: {
                    key: 'promotionHistorys',
                    render: (histories, record) => record.isUsed ? 
                                            <p className="m-b-none view-history" onClick={() => this.props.showHistory(record)}>
                                                {this.props.t('item.promotions.viewMore')} 
                                            </p>
                                            : this.props.t('item.promotions.notUse')
                },
                isActive: {
                    width: 250,
                    key: 'isActive',
                    render: (isActive) => (
                        <StatusComponent color={isActive ? 'green' : 'red'}
                            label={isActive ? this.props.t('item.promotions.active') : this.props.t('item.promotions.deactive')} />
                    ),
                    filters: [
                        { value: true, text: this.props.t('item.promotions.active') },
                        { value: false, text: this.props.t('item.promotions.deactive') }
                    ],
                    filterMultiple: false,
                },
                updateAt: {
                    key: 'updateAt',
                    render: (value, record) => value && moment(moment.utc(value).toDate().toJSON()).format(DATE_TIME_FORMAT.DATE_TIME)
                },
                schedules: {
                    key: 'schedules',
                    render: (schedules, record) => schedules.length > 0 && <p className="m-b-none view-history" onClick={() => this.props.showSchedules(record)}>
                    {this.props.t('item.promotions.view')} 
                </p>
                },
                action: {
                    width: 100,
                    align: 'right',
                    key: 'action',
                    render: (text, record) => this.renderActionComponent(record),
                }
            },
            filters: {},
            selectedRowKeys: [],
        };
    }

    resetSelectedRowKeys() {
        const { setShowHideActiveDeactivatedPromotion } = this.props;
        this.setState({
            selectedRowKeys: [],
        })
        setShowHideActiveDeactivatedPromotion && setShowHideActiveDeactivatedPromotion(false, false, []);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.promotions !== prevProps.promotions) {
            this.resetSelectedRowKeys();
        }
    }

    render() {
        const { loading, pagination, promotions, permissions, setShowHideActiveDeactivatedPromotion } = this.props;
        const { titleItemTable, modelItem, componentTable, selectedRowKeys } = this.state;
        const rowSelection = {
            selectedRowKeys: selectedRowKeys,
            hideDefaultSelections: true,
            onChange: (selectedRowKeys, selectedRows) => {
                if (selectedRows && selectedRows.length > 0) {
                    const currentTotalSelectedRows = selectedRows.length;
                    const firstRowStatus = selectedRows[0].isActive;
                    let totalSameStatusWithFirstRow = 0;
                    selectedRows.map(item => {
                        if (item && item.isActive === firstRowStatus) {
                            totalSameStatusWithFirstRow += 1;
                        }
                    })
                    setShowHideActiveDeactivatedPromotion && setShowHideActiveDeactivatedPromotion(currentTotalSelectedRows === totalSameStatusWithFirstRow, firstRowStatus, selectedRows);
                } else {
                    setShowHideActiveDeactivatedPromotion && setShowHideActiveDeactivatedPromotion(false, false, []);
                }
                this.setState({
                    selectedRowKeys,
                })
            },
        };
        const rowSelectionObj = permissions.allowDeactive ? { rowSelection: rowSelection } : null;
        return (
            <ListComponent
                tableKey="promotions-list"
                classChildren="p-0" classParent="m-0"
                rowKey={(record, k) => record.id ? record.id : k}
                loading={{ spinning: loading, size: 'large' }}
                dataSource={Func.getDataSource(promotions || [], modelItem)}
                columns={Func.columnsTable({
                    titleTable: titleItemTable,
                    component: componentTable,
                    itemName: 'promotions'
                })}
                onChange={this.props.onChange}
                pagination={{ total: pagination.totalCount, totalPage: pagination.totalPage, current: pagination.defaultCurrent, pageSize: pagination.pageSize }}
                componentTableList={{}}
                onColumnVisibleChange={this.onColumnVisibleChange}
                {...rowSelectionObj}
            />
        );
    }

    renderActionComponent(item) {
        const { t, permissions, openUpdateStatus } = this.props;
        return (
            <Fragment>
                {
                    permissions && permissions.allowUpdateStatus &&
                    <Tooltip title={this.props.t(`action.${ item.isActive ? 'deactive' : 'active' }`)} placement="top">
                        <Icon 
                            type={item.isActive ? 'lock' : 'unlock'} 
                            className="fs20 colorPrimary" 
                            theme="twoTone" 
                            twoToneColor={item.isActive ? '#C70039' : '#52c41a'} 
                            onClick={() => openUpdateStatus(item.__data__)} 
                        />
                    </Tooltip>
                }
            </Fragment>
        )
    }

    onColumnVisibleChange = (column, isVisibled) => {
        const { componentTable } = this.state;
        componentTable[column.dataIndex].visible = isVisibled;
        this.setState({ componentTable })
    }


}

export default withTranslation(undefined, { withRef: true })(PromotionList);
